@if (cartValidationResult != undefined) {
  @if (shouldDisplayCartErrorList == true) {
    <app-cart-validation-result-cart [shouldDisplayValidResult]="shouldDisplayValidResult">
    </app-cart-validation-result-cart>
  }
  @if (shouldDisplayCartItemErrorList == true) {
    @for (cartItemValidation of cartValidationResult.itemValidationErrorList; track cartItemValidation) {
      <app-cart-validation-result-cart-item [cartItemValidationError]="cartItemValidation">
      </app-cart-validation-result-cart-item>
    }
  }
}
